import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Confirm,
  Header,
  Icon,
  Popup,
  Segment,
  Message
} from "semantic-ui-react";

import ReactTable from "react-table";
import matchSorter from 'match-sorter';
import { AppContext } from "../../utils/context";
import request from "../../utils/request";
import PasswordPrompt from "../../components/common/PasswordPrompt";

class DevicesTab extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      isMounted: false,
      data: [],
      ecommerceSellerData: [],
      isLoading: true,
      confirmOpen: false,
      confirmId: false,
      confirmTitle: "",
      confirmDescription: "",
      confirmSingleAction: "",
      eventId: this.props.match.params.id,
      open: false,
      pollInterval: false,
      xhrResponse: {
        status: "",
        message: ""
      },
      activateEcommBtnLoading: true,
      openPasswordPrompt: false,
      passwordProtectManualAction: context?.config.manual_deactivation_enabled ?? false
    };
    this.fetchData = this.fetchData.bind(this);
    this.show = this.show.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
  }

  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };

  componentWillUnmount = () => {
    clearInterval(this.state.pollInterval);
  };

  componentDidUpdate = prevState => {
    // Verify ecommerce seller status does not match previous state
    if (this.state.ecommerceSellerData && prevState.ecommerceSellerData && this.state.ecommerceSellerData !== prevState.ecommerceSellerData) {
        this.setState({ activateEcommBtnLoading: false });
    }
  }

  fetchData = () => {
    clearInterval(this.state.pollInterval);
    const { eventId } = this.state;
    let payload = {
      eventId: eventId,
      ts: Date.now()
    };
    return request.get(this, `api:/event/${eventId}/devices`, payload).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)

        let ecommerceSellerData = res.data && res.data.filter(datum => {
            return datum['seller'] === "E-commerce Sales";
        });

        this.setState({
            data: res.data,
            ecommerceSellerData: ecommerceSellerData,
            isLoading: false,
            activateEcommBtnLoading: false,
            pollInterval: false
        }, () => this.handlePoll());
    });
  };

  handlePoll = () => {
    if (!this.state.pollInterval) {
      let poll = setInterval(this.fetchData, 15000);
      this.setState({
        pollInterval: poll
      });
    }
  };

  show = (id, title, description, action = "") => { // handle confirm dialog open
    this.setState({
      confirmOpen: true,
      confirmId: id,
      confirmTitle: title,
      confirmDescription: description,
      confirmSingleAction: action
    });
  };

  handleConfirm = () => { // handle confirm dialog callback function
    this.setState({ isLoading: true });
    if (this.state.confirmId === 0) {
        this.eventDeactivation();
    } else if (this.state.confirmId === -1) {
        this.activateAllRSU();
    } else if (this.state.confirmId === -2) {
        this.deactivateAllRSU();
    } else if (this.state.confirmId === -3) {
        this.ActivateEcommerce();
    } else if (this.state.passwordProtectManualAction) { // check if password required
        this.handleManualAction();
    } else {
        this.singleDeviceAction();
    }
    this.setState({ isLoading: false }, () => this.handleCancel());
  };

  handleCancel = () => { // handle confirm dialog close
    if (this.state.openPasswordPrompt) return false;
    this.setState({
      confirmOpen: false,
      confirmId: false,
      confirmTitle: "",
      confirmDescription: ""
    });
  }

  handleCancelPassword = () => { // handle password prompt close
    this.setState({
        openPasswordPrompt: false,
        confirmOpen: false,
        confirmId: false,
        confirmTitle: "",
        confirmDescription: ""
    });
  }

  handleResponse = (resp) => { // handle post responses
    let customMessage = !resp.success && resp.name ? resp.isAddon ? `${resp.name} ${resp.message}` : `Another event named ${resp.name} ${resp.message}` : resp.message;
    this.setState({
      xhrResponse: {
        status: resp.success ? "success" : "error",
        message: resp.success ? resp.message : customMessage
      }
    }, () => this.fetchData());
  }

  handleManualAction = () => { // handle password prompt - only applies to manual deactivation
    if (this.state.confirmSingleAction !== "deactivate") {
        this.singleDeviceAction();
    } else this.setState({ openPasswordPrompt: true });
  }

  singleDeviceAction = (e = false) => { // manually deactivate or activate rsu using unit id
    e && e.stopPropagation();
    let payload = {
      utv_id: this.state.confirmId
    };
    let action = this.state.confirmSingleAction === 'activate' ? 'activate' : 'deactivate';
    return request.post(this, `api:/event/${this.state.eventId}/${action}`, payload).then(resp => {
      this.handleResponse(resp);
    });
  };

  activateAllRSU = () => { // activate all rsu
    let payload = {
      eventId: this.state.eventId
    };
    return request.post(this, `api:/event/${this.state.eventId}/activate`, payload).then(resp => {
      this.handleResponse(resp);
    });
  }

  deactivateAllRSU = () => { //deactivate rsu only
    let payload = {
      eventId: this.state.eventId,
      onlyRSU: true
    };
    return request.post(this, `api:/event/${this.state.eventId}/deactivate`, payload)
      .then(resp => {
        this.handleResponse(resp);
      });
  };

  eventDeactivation = () => { // deactivate all sales (rsu and e-commerce)
    let payload = {
      eventId: this.state.eventId
    };
    return request.post(this, `api:/event/${this.state.eventId}/deactivate`, payload)
      .then(resp => {
        this.handleResponse(resp);
      });
  };

  ActivateEcommerce = () => { // Activate E-commerce seller
    this.setState({ activateEcommBtnLoading: true });

    return request
      .post(this, `api:/event/${this.state.eventId}/activate-ecomm-sales`)
      .then(resp => {
        this.handleResponse(resp);
      });
  };

  render() {
    const {
      confirmOpen,
      confirmTitle,
      confirmDescription,
      data,
      isLoading,
      activateEcommBtnLoading,
      xhrResponse,
      ecommerceSellerData
    } = this.state;

    const activateRSUDescription = (<Segment basic>
        <Header as="h4" color="red">
          This action will set this event as the active RSU enabled event
        </Header>
        <p>
          <strong>
            Please make sure that all the other active events have their RSUs deactivated
          </strong>{" "}
        </p>
        <p>
          This action will also re-activate any RSUs associated with the event
          which were previously deactivated.
        </p>
    </Segment>);

    const deactivateRSUDescription = (<Segment basic>
        <Header as="h4" color="red">
          All devices must be deactivated and must not have any stored
          tickets before you may pick a winning number.
        </Header>
        <p>
          <strong>
            If the "Deactivation Confirmed" column does not change to a
            green check mark:
          </strong>{" "}
          Make sure the device is powered on and connected to the
          internet, and the Bump application is open. Alternately, you may
          click the{" "}
          <Icon
            name="check square outline"
            size="large"
            className="primary"
            fitted
          />{" "}
          button next to any seller below to manually confirm
          deactivation. This button should only be used if you are
          absolutely positive the device has 0 stored tickets.
        </p>
        <p>
        <strong>If a device has stored tickets:</strong>
         Make sure the device is ON, the Bump app is open and a network connection is available.
          If a tablet is unable to connect to the network, you may use the "Tablet Import" system
           to manually upload any stored tickets or call support.
        </p>
    </Segment>);

    const manuallyDeactivateRSUDescription = (<Segment basic>
        <Header as="h2" color="red">
          NOTE: Any stored tickets in this device WILL NOT be included in the draw!
          </Header>
          <Header as="h3" color="red">
          This button should only be used if you are
          absolutely positive the device has 0 stored tickets.
          </Header>
          <strong>If a device has stored tickets:</strong>
           Make sure the device is ON, the Bump app is open and a network connection is available.
            If a tablet is unable to connect to the network, you may use the "Tablet Import" system
             to manually upload any stored tickets or call support.
    </Segment>);

    const manuallyActivateRSUDescription = (<Segment basic>
      <Header as="h2" color="red">
        NOTE: This action will reactivate the selected device for this event
      </Header>
    </Segment>);

    const activateEcommerceDescription = (<Segment basic>
          The following action will reactivate the E-commerce sales for this event.
    </Segment>);

    const deactivateAllDescription = (<Segment basic>
        <Header as="h4" color="red">
          This action will deactivate all sales (RSU and E-Commerce) associated
          with the event and cannot be undone.
        </Header>
        <p>
          <strong>
            All sales (RSU and E-Commerce) must be deactivated
            before you may pick a winning number.
          </strong>
        </p>
        <p>
          <strong>
            If the "Deactivation Confirmed" column does not change to a
            green check mark:
          </strong>{" "}
          Make sure the tablet is powered on and connected to the
          internet, and the Bump application is open. Alternately, you may
          click the{" "}
          <Icon
            name="check square outline"
            size="large"
            className="primary"
            fitted
          />{" "}
          button next to any seller below to manually confirm
          deactivation. This button should only be used if you are
          absolutely positive the device has 0 stored tickets.
        </p>
        <p>
          <strong>If a device has stored tickets:</strong>
           Make sure the device is ON, the Bump app is open and a network connection is available.
            If a tablet is unable to connect to the network, you may use the "Tablet Import" system
             to manually upload any stored tickets or call support.
        </p>
    </Segment>);

    const columns = [
      {
        Header: "Action",
        id: "device_action",
        accessor: d =>
        (<div>
            {(d.can_deactivate && d.deactivated == 0)  ? (<Link to="#" onClick={() => this.show(
            d.id,
            `manually deactivate ${d.device_name !== "-" ? d.device_name : ""}`,
              manuallyDeactivateRSUDescription,
              'deactivate'
            )}>
            <Popup content="Manually deactivate this device" trigger={<Icon
              link
              name="power off"
              color="red"
              className="primary"
              size="large"
            />}/>
            </Link>) : <div></div>}
            {(d.deactivated !== 0 && d.can_deactivate) ? (<Link to="#" onClick={() => this.show(
            d.id,
            `manually activate ${d.device_name !== "-" ? d.device_name : ""}`,
              manuallyActivateRSUDescription,
              'activate'
            )}>
            <Popup content="Manually activate this device" trigger={<Icon
              link
              name="power off"
              color="green"
              className="primary"
              size="large"
            />}/>
            </Link>)
            : <div></div>}
          </div>),
          filterable: false
      },
      {
        Header: "Unit ID",
        accessor: "unit_id",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["unit_id"] }),
        filterAll: true
      },
      {
        Header: "Seller",
        accessor: "seller",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["seller"] }),
        filterAll: true
      },
      {
        Header: "Device",
        accessor: "device_name",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["device_name"] }),
        filterAll: true
      },
      {
        Header: "Logged In",
        id: "logged_in",
        filterable: false,
        accessor: d => {
            switch (d.logged_in) {
                case 0:
                    return <Icon name="cancel" color="red" />;
                case 1:
                    return <Icon name="check" color="green" />;
                default:
                    return null;
            }
        }
      },
      {
        Header: "Deactivation Confirmed",
        id: "deactivated",
        filterable: false,
        accessor: d =>
          d.deactivated === 0 ?
          (<Icon name="cancel" color="red" />) :
          d.deactivated > 1 ?
          (<><Icon name='check' color="green" />(Manual)</>) :
          (<Icon name="check" color="green" />)
      },
      {
        Header: "Ping",
        accessor: "ping",
        filterable: false
      }
    ];

    return (
      <Segment basic success={xhrResponse.status === "success"} error={xhrResponse.status === "error"}>
        <Confirm
          open={confirmOpen}
          header={"Are you sure you want to " + confirmTitle + "?"}
          content={confirmDescription}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        {this.state.openPasswordPrompt && <PasswordPrompt
            isOpen={this.state.openPasswordPrompt}
            onConfirm={this.singleDeviceAction}
            onCancel={this.handleCancelPassword}
        />}

        {xhrResponse.status === "success" && <Message success content={xhrResponse.message} />}
        {xhrResponse.status === "error" && <Message error content={xhrResponse.message} />}
        <Segment basic clearing>
            <Button
                onClick={() => this.show(-1, "activate all RSUs", activateRSUDescription)}
                positive
                floated="left"
                content="Activate RSUs"
            />
            {ecommerceSellerData?.length > 0 && <Button
                onClick={() => this.show(-3, "activate Ecommerce", activateEcommerceDescription)}
                positive
                floated="left"
                content="Activate Ecommerce"
                disabled={ecommerceSellerData[0] ? ecommerceSellerData[0].deactivated === 0 : false}
                loading={activateEcommBtnLoading}
            />}
            <Button
                onClick={() => this.show(0, "deactivate all sales", deactivateAllDescription)}
                negative
                floated="right"
                content="Deactivate All Sales"
            />
            <Button
                onClick={() => this.show(-2, "deactivate all RSUs", deactivateRSUDescription)}
                negative
                floated="right"
                content="Deactivate RSUs"
            />
        </Segment>
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight eventDevicesListTable"
          loading={isLoading} // Display the loading overlay when we need it
          resizable={true}
          filterable={true}
          showPagination={true}
          defaultPageSize={20}
          defaultSorted={[{ id: "unit_id", desc: false }]}
          minRows={0}
        />
      </Segment>
    );
  }
}

DevicesTab.contextType = AppContext;
export default DevicesTab;
